import React, { useState, useEffect, useRef} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, GpsBaseURL, uniqueToken, Role } from '../../api/DataApis';

import { Link, Navigate, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import "../Users/User.css";
import ReactPaginate from 'react-paginate'; 
import { GrTransaction } from 'react-icons/gr';
import Loader from '../Settings/Loader';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';




  const EmailProcessingLogs = () => {

 


  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [Users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(null);
 
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState("0");
  const [userStatuses, setUserStatuses] = useState({});
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [selectedUser, setSelectedUser] = useState('');
  const [popupInput, setPopupInput] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Limit, setLimit] = useState({});
  const [currentPage, setCurrentPage] = useState(1); 
  const [selectStatusType, setselectedStatusType] = useState("");
  const [file, setFile] = useState(null); // State to hold the selected file
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [UserID, setUserID] =  useState([]);
  const [selectEmail, setSelectEmail] = useState("");
  const [Loaders, setLoaders] =  useState(false);
   const [selectedCorporate, setSelectedCorporate] = useState("");
  const [CorporateData, setCorporateData] = useState([]);
   const [ProductData, setProductData] =  useState([]);


 

 const handlecorporateChange = (selectedOption) => {
  console.log("selectedOption:", selectedOption);
  
  if (selectedOption) {
    setSelectedCorporate(selectedOption._id );
  } else {
    setSelectedCorporate(null); // Reset state when cleared
  }
};
  const corporateOptions = CorporateData?.map(corporate => ({
    value: corporate._id,
    label: `${corporate.corporate_name} (${corporate?.email})`,
    _id: corporate._id,
  }));
  const fetchCorporate = async (page) => {
   let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/corporate`);
    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      
  
      setCorporateData(response.data?.data);
    // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
     
    }
  };
  
  // Re-fetch users whenever searchTerm changes
    useEffect(() => {
      if (Role === "false") {
        fetchCorporate();  // Only fetch corporate data if Role === "false"
      }
    }, [Role]);


  console.log("Roleeeeeee", Role);
   let params = useParams();
    let ImportredID = params?.cid;
  
    console.log("ImportredID", ImportredID);

// console.log("role", Role);
  

  const handleUserID = (userID) => {
    setUserID((prevUserIDs) => {
      if (prevUserIDs.includes(userID)) {
        // If user is already selected, deselect them
        return prevUserIDs.filter((id) => id !== userID);
      } else {
        // If user is not selected, select them
        return [...prevUserIDs, userID];
      }
    });
  };

  const fileInputRef = useRef(null);
 
  const [searchTerms, setSearchTerms] = useState({
    srNo: '',
    name: '',
    email: '',
    phone: '',
    meterTransactions: '',
    rfids: '',
    wallet: '',
    status: '',
    createdDate: '',
    actions: ''
  });

  let navigate = useNavigate();
  const handleSearch = (column, value) => {
    setSearchTerms((prev) => ({
      ...prev,
      [column]: value
    }));
  };

  const handleReset = (event) => {
    event.preventDefault()
     {
  navigate(`/email-processing-logs`);
    }
    }
 

  const dataWithSerialNumbers = filteredData.map((user, index) => ({
    ...user,
    serialNumber: (page - 1) * Limit + index + 1, // Calculate and add serial number as a property
  }));
  
  const displayedData = dataWithSerialNumbers.filter((user) => {
    // Logging serial numbers and search term
    console.log("Filtering user with serial number:", user.serialNumber, "against search term:", searchTerms.srNo);
  
    return (
      (searchTerms.srNo === '' || user.serialNumber.toString() === searchTerms.srNo) && // Exact match for serial number
      (searchTerms.name === '' || user.name?.toLowerCase().includes(searchTerms.name.toLowerCase())) &&
      (searchTerms.email === '' || user.email?.toLowerCase().includes(searchTerms.email.toLowerCase())) &&
      (searchTerms.phone === '' || user.mobile.includes(searchTerms.phone)) &&
      (searchTerms.meterTransactions === '' || (user.meterTransactionCount?.toString().includes(searchTerms.meterTransactions))) &&
      (searchTerms.rfids === '' || (user.rfids?.some((rfid) => rfid.backend_rfid_code.includes(searchTerms.rfids)))) &&
      (searchTerms.wallet === '' || user.wallet_amount?.toString().includes(searchTerms.wallet)) &&
      (searchTerms.status === '' || user.status?.toLowerCase().includes(searchTerms.status.toLowerCase())) &&
      (searchTerms.createdDate === '' || user.createdAt.includes(searchTerms.createdDate))
    );
  });
  
  document.title = "Email Processing Logs";


  
const handleselectedStatusType = (e) => {
  setselectedStatusType(e.target.value);

}


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };


 

 

  const fetchUsers = async (page) => {
    setLoadings(true);
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/email-processing/?`);
 
    const queryParams = [`page=${page}`];
    
    // Add search term to the query params if it's not empty
    // if (searchTerm) queryParams.push(`searchText=${searchTerm}`);
  
    if (searchQuery) queryParams.push(`&searchText=${searchQuery}`);
    if (selectStatusType) queryParams.push(`&status=${selectStatusType}`); 
    if (selectedCorporate) queryParams.push(`&corporate_id=${selectedCorporate}`); 
    //
    
    
    const apiUrl = `${apiEndpoint}${queryParams.join('&')}`;
  
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
      setUsers(response.data.data || []);
      setFilteredData(response.data.data);
      setTotalCount(response.data.count || 0);
      setLimit(response?.data?.limit);
      setPageCount(Math.ceil(response.data.count / response?.data?.limit)); // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
    }
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchUsers(page);
  }, [searchTerm, page]);
  


  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  
 
  
  const handleStatusType = async (event, userId, ) => {
    const status = event.target.value;
  
    setUserStatuses(prevStatuses => ({
      ...prevStatuses,
      [userId]: status
    }));
  
    const url = `${GpsBaseURL}/user/change-status/${userId}`;
    //http://localhost:5000/api/admin/user/change-status/66bd306c0b2f0e2ff46a7fde
    
    const formData = new FormData();
    // formData.append("status", status);
  
    try {
      Swal.fire({
        title: 'Processing...',
        text: 'please wait...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const response = await axios.put(url,
        
        {"status" : status}, {
        headers: {
          "Content-Type": "Application/json",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  
      if (response.data.statusCode === 200) {
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message, 
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.close();
        console.log("Failed to update status", response.data);
      }
    } catch (error) {
      Swal.close();
      console.error("Error updating status:", error);
    }
  };
   const handleSearchTextChange = (e) => {
  setSearchQuery(e.target.value);
};

// Handle submit to fetch filtered data
const handleSearchSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const page = 1; // Always reset to page 1 when searching
  setPage(page); // Ensure pagination resets to the first page

  // Set loading to true while fetching
  setLoadings(true); 

  // Prepare the base URL and query parameters
  let url = `${GpsBaseURL}/email-processing?page=${page}`;
  if (ImportredID) {
    url = decodeURIComponent(`${GpsBaseURL}/email-processing?page=${page}`);
  }
  const params = [];

  // Add search term if present
  if (searchQuery.trim()) {
      params.push(`searchText=${searchQuery}`);
  }
  if (selectedStatusType) {
    params.push(`status=${selectStatusType}`);
}


  if (selectedCorporate) {
    params.push(`corporate_id=${selectedCorporate}`);
}

  // Append query parameters to the URL
  if (params.length) {
      url += `&${params.join('&')}`;
  }

  try {
      const res = await axios.get(url, {
          headers: {
              Authorization: `Bearer ${uniqueToken}`, // Include authorization token
          },
      });

      if (res && res?.data && res?.data?.data) {
          setFilteredData(res?.data?.data); // Update filtered data
          setTotalCount(res?.data?.count); // Set total count based on the filtered data length
          setPageCount(Math.ceil(res?.data?.count / Limit)); // Update page count based on results
      } else {
          setFilteredData([]); // If no data is returned, set filtered data to empty
          setTotalCount(0); // If no data is returned, set totalCount to 0
      }
      
  } catch (error) {
      console.error("Error fetching filtered data:", error);
  } finally {
      setLoadings(false); // Set loading to false after fetching
  }
};


const handleButtonClick = () => {
  fileInputRef.current.click(); // Trigger the hidden file input click
};
 console.log("users", Users);
  console.log("totalCount", totalCount);
  console.log("pagecount", pageCount);
  console.log("limit", Limit);
  console.log("filtredData", filteredData);
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    <h4 className="mb-0 me-3">Email Processing Logs({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
    </div>
  </div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
  <form className="form-horizontal" role="form" style={{ marginTop: "5px" }}>
    <div
      className="row px-3"
      style={{
        display: "flex",
        alignItems: "center",
        //gap: "10px", // Consistent spacing between filters
        flexWrap: "wrap", // Allow wrapping on smaller screens
      }}
    >
<div className="col-md-2 col-sm-12">
  <div className="form-group">
    <select
      value={selectStatusType} // Bind the dropdown's value to the state
      onChange={handleselectedStatusType} // Update state on selection change
      className="form-control select2 select2-offscreen"
      style={{
        height: "38px", // Consistent height
        width: '100%', // Make width responsive
      }}
    >
      <option value="">Select Status</option>
      <option value="Processing">Processing</option>
      <option value="Completed">Completed</option>
      <option value="Pending">Pending</option>
    </select>
  </div>
</div>
{ Role === "false" && (
<div className="col-md-2 col-sm-12">
  <div className="form-group">
  <Select
                                                     options={corporateOptions}
                                                     onChange={handlecorporateChange}
                                                       value={selectedCorporate ? corporateOptions?.find(option => option.value === selectedCorporate) : null}
                                                         placeholder="Select Corporate"
                                                            isClearable
                                                              styles={{
                                                              control: (base) => ({
                                                             ...base,
                                                           height: '38px', 
                                                         width: '100%',
                                                       boxShadow: 'none',
                                                    minWidth: '0',
                                                 flex: 1,
                                               }),
                                             }}
                                            />
  </div>
</div>
)}


<div className="col-md-2 col-sm-12">
  <div className="form-group">
  <input
    placeholder="Find Data Here"
    className="form-control"
    style={{
      //width: "calc(100% - 150px)", // Increased available width for the input box
      borderRadius: "8px",
      padding: "6px 10px",
      marginRight: "10px",
      height: "38px", // Consistent height
    }}
    value={searchQuery}
    onChange={handleSearchTextChange}
  />
  </div>
</div>





<div className="col-md-2 col-sm-12" style={{ display: "flex", alignItems: "center" }}>

    {/* Search Button */}
    <button
      className="btn btn-primary"
      onClick={handleSearchSubmit} // Calls the handleSearchSubmit function
      style={{
        marginLeft: "10px", // Space between the input and button
        height: "38px", // Consistent height
        width: "80px", // Consistent width for the Search button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Search
    </button>

    {/* Reset Button */}
    <button
      className="btn btn-primary"
      onClick={handleReset} // Calls the handleReset function
      style={{
        marginLeft: "10px", // Space between the buttons
        height: "38px", // Consistent height
        width: "80px", // Slightly smaller width for Reset button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Reset
    </button>

</div>

    </div>
  </form>
</div>
{Loaders ? (
          <div className="spinner"></div> // Show spinner when loading
        ) : (
          ''
        )}



              <div className="card-body" style={{ marginLeft: "-19px" }}>
  {loadings ? (
    <Loader /> 
  ) : totalCount === 0 ? (
    <div className="text-center">
      <h5>No User Data Found</h5> {/* Message to indicate no data found */}
    </div>
  ) : (
    <>
    <div className="table-responsive">
      <table
        className="display dataTable"
        id="advance-1"
        style={{ tableLayout: 'auto', width: '100%', borderCollapse: 'collapse' }}
      >
       <thead>
  <tr>


    <th style={{ minWidth: '80px' }}>Sr No</th>
    <th style={{ minWidth: '200px' }}>Title</th>
    <th style={{ minWidth: '200px' }}>Product Name</th>
    {Role ==="false" && (
    <th style ={{minWidth: '200px'}}>Corporate Name</th>
  )}
    <th style={{ minWidth: '150px' }}>Total Email</th>
    <th style={{ minWidth: '150px' }}>Email Delivered</th>
    <th style={{ minWidth: '150px' }}>Email Not Delivered</th>
    <th style={{ minWidth: '150px' }}>Comment</th>
    <th style={{ minWidth: '270px' }}>Status</th>
    <th style={{ minWidth: '150px' }}>Created At</th>
    <th style={{ minWidth: '150px' }}>Created By</th>

     </tr>
</thead>

        <tbody>
          {displayedData?.map((user, index) => (
            <tr key={index}>
              <td>{(page - 1) * Limit + index + 1}</td>
              <td>{user?.title}</td>
            <td>{user?.product_name}</td>
            {Role === "false" && (
            <td>{user?.corporate_name}</td>
          )}
            <td>
  <Link to={{
    pathname: `/view-mail-sent-users/${user?._id}`,
    // Sending the static word "Delivered"
  }}>
    {user?.total_email}
  </Link>
</td>


<td>
  <Link to={{
    pathname: `/view-mail-sent-users/${user?._id}`,
    // Passing the static word "Delivered"
  }}   state=  {{ state: "Delivered" }}>
    {user?.email_delivered}
  </Link>
</td>
<td>
              <Link to={{
    pathname: `/view-mail-sent-users/${user?._id}`,
     // Sending the static word "Delivered"
  }}  state=  {{ state: "NotDelivered", userViewData: user }}>
             {user?.email_not_delivered}
             </Link>
              </td>
              <td>{user?.comment}</td>
              <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
  <button
    style={{
      width: "106px",
      textAlign: "center",  // Ensures horizontal centering
      padding: "5px",
      fontSize: "12px",
      display: "flex",        // Makes the button a flex container
      justifyContent: "center", // Centers content horizontally
      alignItems: "center",     // Centers content vertically
      backgroundColor: 
        user?.status === 'Pending' ? 'yellow' :
        user?.status === 'Processing' ? 'orange' :
        user?.status === 'Completed' ? 'green' : 'purple',  // Default color
    }}
    className="btn"
  >
    {user?.status}
  </button>
</td>


              <td style={{ whiteSpace: 'nowrap' }}>{user?.createdAt} </td>
              <td style={{ whiteSpace: 'nowrap' }}>{user?.created_by} </td>
       
              <td>
              {user?.updatedAt}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
</div>
    <div className="pagination-container mt-4">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={page - 1} 
        />
      </div>
    </>
  )}
</div>

 </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default EmailProcessingLogs;
